/** Виджет чата/поддержки Bitrix24 (site_button loader). */
export const DEFAULT_BITRIX24_SITE_BUTTON_SRC =
  "https://cdn-ru.bitrix24.ru/b7654435/crm/site_button/loader_16_6l7ij0.js";

/**
 * URL loader site_button.
 * NEXT_PUBLIC_BITRIX24_SITE_BUTTON_URL →
 * NEXT_PUBLIC_BITRIX24_SITE_BUTTON_URL_DEV|PROD → дефолт.
 */
export function getBitrix24SiteButtonSrc(): string {
  const shared = process.env.NEXT_PUBLIC_BITRIX24_SITE_BUTTON_URL?.trim();
  if (shared) return shared;

  const appEnv = (
    process.env.APP_ENV ||
    process.env.NEXT_PUBLIC_APP_ENV ||
    process.env.NODE_ENV ||
    ""
  ).toLowerCase();
  const isProd = appEnv === "production" || appEnv === "prod";
  const byEnv = isProd
    ? process.env.NEXT_PUBLIC_BITRIX24_SITE_BUTTON_URL_PROD?.trim()
    : process.env.NEXT_PUBLIC_BITRIX24_SITE_BUTTON_URL_DEV?.trim();
  if (byEnv) return byEnv;

  return DEFAULT_BITRIX24_SITE_BUTTON_SRC;
}

/** Публичные страницы, где допустим виджет чата Bitrix24. */
export function isBitrix24SiteButtonPath(pathname: string | null | undefined): boolean {
  if (!pathname) return false;
  return !pathname.startsWith("/admin");
}

/**
 * Лаунчер слева только на сборке отчёта (форма / генерация) и только
 * пока экран достаточно узкий, что FAB может наехать на кнопки справа.
 */
export function shouldBitrix24LauncherLeft(
  pathname: string | null | undefined,
): boolean {
  if (!pathname) return false;
  return (
    pathname === "/reports/create" || pathname.startsWith("/reports/create/")
  );
}

/** Ниже этой ширины чат уезжает влево на форме/генерации. */
export const BITRIX_LAUNCHER_LEFT_MAX_WIDTH_PX = 1580;

export function isBitrix24LauncherLeftViewport(): boolean {
  if (typeof window === "undefined") return false;
  return window.matchMedia(
    `(max-width: ${BITRIX_LAUNCHER_LEFT_MAX_WIDTH_PX}px)`,
  ).matches;
}

/** true = режим «чат слева при узком экране» активен по контексту страницы. */
export function isBitrix24LauncherCornerRequested(): boolean {
  if (typeof document === "undefined") return false;
  return document.documentElement.dataset.ixBxLauncherCorner === "left";
}

const BITRIX_WIDGET_HIDE_STYLE_ID = "idealitika-bitrix-widget-hide";
const BITRIX_LAUNCHER_CORNER_ATTR = "ixBxLauncherCorner";

type LauncherCornerSource = "path" | "generation";

const launcherCornerSources: Record<LauncherCornerSource, boolean> = {
  path: false,
  generation: false,
};

function applyBitrix24LauncherCorner(): void {
  if (typeof document === "undefined") return;
  const left =
    launcherCornerSources.path || launcherCornerSources.generation;
  if (left) {
    document.documentElement.dataset[BITRIX_LAUNCHER_CORNER_ATTR] = "left";
  } else {
    delete document.documentElement.dataset[BITRIX_LAUNCHER_CORNER_ATTR];
  }
}

/** Включает/выключает «чат слева» от конкретного источника (форма / генерация). */
export function setBitrix24LauncherCornerSource(
  source: LauncherCornerSource,
  left: boolean,
): void {
  launcherCornerSources[source] = left;
  applyBitrix24LauncherCorner();
}

/** @deprecated используйте setBitrix24LauncherCornerSource */
export function setBitrix24LauncherCorner(
  corner: "left" | "right" | null,
): void {
  setBitrix24LauncherCornerSource("generation", corner === "left");
}

/** Скрыть уже загруженный виджет (например после client-навигации в /admin). */
export function setBitrix24WidgetHidden(hidden: boolean): void {
  if (typeof document === "undefined") return;

  const existing = document.getElementById(BITRIX_WIDGET_HIDE_STYLE_ID);
  if (hidden) {
    if (!existing) {
      const style = document.createElement("style");
      style.id = BITRIX_WIDGET_HIDE_STYLE_ID;
      style.textContent = `
.b24-widget-button-wrapper,
.b24-widget-button-shadow,
.bx-livechat-wrapper,
.bx-livechat-form-wrapper {
  display: none !important;
  visibility: hidden !important;
  pointer-events: none !important;
}`;
      document.head.appendChild(style);
    }
    document.documentElement.dataset.ixBxWidgetHidden = "1";
    return;
  }

  existing?.remove();
  delete document.documentElement.dataset.ixBxWidgetHidden;
}
